module.exports = {
	"id": "MM",
	"name": "Myanmar",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.049464,
			"12": 0.002061,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.006183,
			"18": 0.006183,
			"19": null,
			"20": 0.008244,
			"21": 0.004122,
			"22": 0.008244,
			"23": 0.002061,
			"24": 0.006183,
			"25": 0.02061,
			"26": 0.006183,
			"27": 0.004122,
			"28": 0.012366,
			"29": 0.030915,
			"30": 0.006183,
			"31": 0.094806,
			"32": 0.04122,
			"33": 0.030915,
			"34": 0.006183,
			"35": 0.014427,
			"36": 0.002061,
			"37": null,
			"38": 0.026793,
			"39": 0.008244,
			"40": 0.004122,
			"41": null,
			"42": 0.004122,
			"43": 0.049464,
			"44": 0.022671,
			"45": 0.037098,
			"46": 0.022671,
			"47": 0.024732,
			"48": 0.016488,
			"49": 0.10305,
			"50": 0.047403,
			"51": 0.121599,
			"52": 0.133965,
			"53": 4.208562,
			"54": 0.98928,
			"55": 0.037098,
			"56": 0.010305,
			"57": null
		},
		"firefox": {
			"2": 0.024732,
			"3": 0.010305,
			"4": 0.022671,
			"5": 0.012366,
			"6": 0.006183,
			"7": 0.006183,
			"8": 0.004122,
			"9": 0.010305,
			"10": 0.010305,
			"11": 0.026793,
			"12": 0.072135,
			"13": 0.02061,
			"14": 0.02061,
			"15": 0.014427,
			"16": 0.012366,
			"17": 0.018549,
			"18": 0.016488,
			"19": 0.037098,
			"20": 0.014427,
			"21": 0.049464,
			"22": 0.018549,
			"23": 0.037098,
			"24": 0.022671,
			"25": 0.037098,
			"26": 0.078318,
			"27": 0.043281,
			"28": 0.012366,
			"29": 0.117477,
			"30": 0.107172,
			"31": 0.074196,
			"32": 0.035037,
			"33": 0.049464,
			"34": 0.057708,
			"35": 0.111294,
			"36": 0.098928,
			"37": 0.115416,
			"38": 0.121599,
			"39": 0.166941,
			"40": 0.100989,
			"41": 0.142209,
			"42": 0.10305,
			"43": 0.436932,
			"44": 0.327699,
			"45": 0.154575,
			"46": 0.183429,
			"47": 0.809973,
			"48": 0.776997,
			"49": 4.078719,
			"50": 1.05111,
			"51": 0.026793,
			"52": 0.006183,
			"3.5": 0.006183,
			"3.6": 0.026793
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.014427,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.002061,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.078318,
			"35": null,
			"36": null,
			"37": 0.053586,
			"38": 0.004122,
			"39": 0.004122,
			"40": 0.092745,
			"41": 0.012366,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.016488,
			"6": 0.004122,
			"7": 0.006183,
			"8": 0.065952,
			"9": 0.121599,
			"10": 0.294723,
			"3.1": null,
			"3.2": null,
			"5.1": 0.004122,
			"6.1": 0.004122,
			"7.1": null,
			"9.1": 0.177246
		},
		"ios_saf": {
			"8": 0,
			"10": 2.76238199084,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0744429982306,
			"8.1-8.4": 0.137530284867,
			"9.0-9.2": 0.0656107781016,
			"9.3": 1.00098494796
		},
		"android": {
			"3": 0,
			"4": 0.400355359173,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0500444198966,
			"4.1": 1.44413897416,
			"4.2-4.3": 3.6103474354,
			"4.4": 8.27877689147,
			"4.4.3-4.4.4": 8.3502689199
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.0831075303644,
			"9": 0.0353207004049,
			"10": 0.037398388664,
			"11": 0.355284692308,
			"5.5": null
		},
		"op_mob": {
			"0": 0.266629792529,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00740638312581
		},
		"edge": {
			"12": 0.030915,
			"13": 0.043281,
			"14": 0.068013
		},
		"ie_mob": {
			"10": 0.00782718309859,
			"11": 0.0318678169014
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 3.699574
		},
		"and_uc": {
			"0": 5.63669
		},
		"op_mini": {
			"0": 3.59225682435
		},
		"and_chr": {
			"0": 41.784688
		},
		"and_ff": {
			"0": 0.269926
		}
	},
	"total": 99.2581623117
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MM.json
 ** module id = 590
 ** module chunks = 0
 **/